// src/App/Actions/PlateValidateActions/PlateValidate.js

/* eslint-disable */
import { AuthAPI, UnAuthAPI } from "../../../Auth/requestHandler";
import apiType from "../APIResponseActions/type";
import types from "./type";

export const getPlateValidatePermits = (propertyId) => async (dispatch) => {
  try {
    // Construct the URL with propertyId as a query parameter
    // Ensure propertyId is not null/undefined before adding to URL
    const url = propertyId ? `platevalidate/permits?property_id=${propertyId}` : `platevalidate/permits`;
    const apiResponseFromWrapper = await UnAuthAPI(url, "GET"); // Use the constructed URL
    if (apiResponseFromWrapper && apiResponseFromWrapper.success === 1) {
      dispatch({
        type: types.GET_PLATE_VALIDATE_PERMITS_SUCCESS,
        payload: apiResponseFromWrapper.data,
      });
      dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: "Plate validate permits fetched successfully!",
      });
    } else {
      const errorMessage = apiResponseFromWrapper?.message || "Failed to fetch plate validate permits. (API reported failure)";
      dispatch({
        type: apiType.API_RESPONSE_FAILURE,
        payload: errorMessage,
      });
      console.error("API Error fetching plate validate permits:", errorMessage);
    }
  } catch (error) {
    console.error("ACTION: Error caught in getPlateValidatePermits:", error);
    dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.response?.data?.message || "Failed to fetch plate validate permits.",
    });
    throw error;
  }
};

// Action to update a permit's active status (Deactivate/Activate)
export const updatePermitStatus = (data) => async (dispatch) => {
  try {
    const response = await AuthAPI(undefined, "platevalidate/update-permit-status", "POST", data);

    if (!response?.data || typeof response.data !== "object") {
      console.warn("updatePermitStatus: Unexpected response structure", response.data);
      return;
    }

    // Proceed with normal reducer update
    dispatch({
      type: types.UPDATE_PERMIT_STATUS_SUCCESS,
      payload: response.data, // only safe if it has `id`
    });

    dispatch({
      type: apiType.API_RESPONSE_SUCCESS,
      payload: response.data.message || "Permit status updated successfully!",
    });
  } catch (error) {
    console.error("ACTION: updatePermitStatus - Error caught:", error);

    dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.response?.data?.message || "Failed to update permit status.",
    });
    throw error;
  }
};

// Action to deactivate permits when a PlateValidate lot is deleted
export const deactivatePermitsOnLotDelete = ({ lot_id, property_id, user_id }) => async (dispatch) => {
  try {
    const response = await AuthAPI(undefined, "platevalidate/deactivate-permits-on-lot-deactivate", "POST", {
      lot_id,
        property_id,
        user_id,
    });

      // Normalize the response structure
      const responseData = response?.data || response;

if (responseData?.success === 1) {
  const updatedPermits = responseData?.updatedPermits || [];

  dispatch({
    type: types.DEACTIVATE_PERMITS_ON_LOT_DELETE_SUCCESS,
    payload: updatedPermits,
  });

  dispatch({
    type: apiType.API_RESPONSE_SUCCESS,
    payload: responseData.message || "Permits deactivated due to PlateValidate lot deletion.",
  });

  if (property_id) {
    dispatch(getPlateValidatePermits(property_id));
  }

  return responseData;
} else {
      throw new Error(responseData?.message || "Unknown error in backend response");
    }

  } catch (error) {
    console.error("ACTION: Error in deactivatePermitsOnLotDelete:", error);
    dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.response?.data?.message || "Failed to deactivate permits on lot delete.",
    });
    throw error;
  }
};

export const deletePlateValidateDiscount = ({ lot_id, property_id }) => async (dispatch) => {
  try {
    const response = await AuthAPI(undefined, "merchant_codes/delete-platevalidate-discount", "POST", {
      lot_id,
      property_id,
    });

    const responseData = response?.data || response;

    if (responseData?.success === 1) {
      dispatch({
        type: types.DELETE_PLATE_VALIDATE_DISCOUNT_SUCCESS,
        payload: { lot_id, property_id },
      });

      dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: responseData.message || "Discount successfully deleted.",
      });

      // Optionally refresh permit list after deletion
      if (property_id) {
        dispatch(getPlateValidatePermits(property_id));
      }

      return responseData;
    } else {
      throw new Error(responseData?.message || "Unknown error in backend response");
    }

  } catch (error) {
    console.error("ACTION: deletePlateValidateDiscount - Error caught:", error);
    dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.response?.data?.message || "Failed to delete PlateValidate discount.",
    });
    throw error;
  }
};
